import NTopNBottom from "../../components/NTopNBottom";
// 主图
import bannerImg from "../../assets/weddingDress20220409/banner.jpg";
import navColor from "../../assets/weddingDress20220409/nav/color.png";
// 背景
import navBg from "../../assets/weddingDress20220409/nav/nav_bg.png";
// 定位背景
import navBgFixed from "../../assets/weddingDress20220409/nav/nav_fix.png";
// 标题选中文字
import far1 from "../../assets/weddingDress20220409/nav/far1.png";
import far1_active from "../../assets/weddingDress20220409/nav/far1_active.png";
import far2 from "../../assets/weddingDress20220409/nav/far2.png";
import far2_active from "../../assets/weddingDress20220409/nav/far2_active.png";
import far3 from "../../assets/weddingDress20220409/nav/far3.png";
import far3_active from "../../assets/weddingDress20220409/nav/far3_active.png";
import son1 from "../../assets/weddingDress20220409/nav/son1.png";
import son1_active from "../../assets/weddingDress20220409/nav/son1_active.png";
import son2 from "../../assets/weddingDress20220409/nav/son2.png";
import son2_active from "../../assets/weddingDress20220409/nav/son2_active.png";

import calcRemFn from "../calcRem";
// 经典款轻婚纱-情侣
const SINGLE_PRO_ID = 28407
// 经典款轻婚纱-单人
const FAMILY_PRO_ID = 27184

const navCss = {
  navWrap: {
    minHeight: calcRemFn(193.5),
    backgroundImage: `url(${navColor})`,
    boxSizing: "border-box",
    marginTop: calcRemFn(0)
  },
  navCtn: {
    height: calcRemFn(184.5),
    backgroundImage: `url(${navBg})`
  },
  navCtnFixed: {
    margin: `${calcRemFn(-10)} 0 0 0`,
    height: calcRemFn(184.5),
    backgroundImage: `url(${navBgFixed})`
  },
  topBtnLayout: {
    padding: `${calcRemFn(28)} ${calcRemFn(60)} ${calcRemFn(0)}`
  },
  topBtnBaseCss: {
    width: calcRemFn(57),
    height: calcRemFn(19),
    marginTop: calcRemFn(10)
  },
  bottomBtnLayout: {
    padding: `${calcRemFn(15)} ${calcRemFn(120)} ${calcRemFn(0)}`
  },
  bottomBtnBaseCss: {
    width: calcRemFn(57),
    height: calcRemFn(19)
  },
  thirdBtnLayout: {
    height: calcRemFn(40),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    padding: `${calcRemFn(10)} ${calcRemFn(50)} ${calcRemFn(20)}`
  },
  thirdBtnBaseCss: {
    width: calcRemFn(57),
    height: calcRemFn(19),
  },
  LineCss3: {
    width: calcRemFn(.5),
    height: calcRemFn(10),
    backgroundColor: 'rgba(75, 64, 53 ,.7)',
  }
};

const navData = {
  // 三级分隔符控件
  showLine3: true,
  component: NTopNBottom,
  top: [
    {
      key: "top1",
      show: true,
      img: far1,
      img_actived: far1_active
    },
    {
      key: "top2",
      show: true,
      img: far3,
      img_actived: far3_active
    },
    {
      key: "top3",
      show: true,
      img: far2,
      img_actived: far2_active
    }
  ],
  bottom: {
    top1: [
      {
        key: "_i1",
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: "_i2",
        show: true,
        img: son1,
        img_actived: son1_active
      }
    ],
    top2: [
      {
        key: "_i1",
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: "_i2",
        show: true,
        img: son1,
        img_actived: son1_active
      }
    ],
    top3: [
      {
        key: "_i1",
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: "_i2",
        show: true,
        img: son1,
        img_actived: son1_active
      }
    ]
  }
};

function handleThirdMap (start = 0, end, thirdNavName, stop) {
  const list = Array.from({ length: end - start }, (x, i) => i + start);
  let flag = 0
  if (stop) flag = stop
  return list.map((j, index) => {
    let n = ((j >= flag) && flag) ? j + 2 : j + 1
    let key = `_t${index + 1}`;
    const img = require(`../../assets/weddingDress20220409/nav/${thirdNavName}_${n}.png`);
    const imgActived = require(`../../assets/weddingDress20220409/nav/${thirdNavName}_${n}_active.png`);
    return {
      key,
      show: true,
      img,
      img_actived: imgActived
    };
  });
}

function handleThirdNav (secoundNav) {
  const thirdNavMap = {};
  for (let firstKey in secoundNav) {
    const navs = secoundNav[firstKey];
    navs.forEach(item => {
      const thirdKey = firstKey + item.key;
      if (firstKey === "top1") {
        if (item.key === "_i1") {
          thirdNavMap[thirdKey] = handleThirdMap(0, 2, "third1");
        } else if (item.key === "_i2") {
          thirdNavMap[thirdKey] = [
            {
              key: "_t1",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third1_2_1.png`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third1_2_1.png`),
            }
          ]
        }
      } else if (firstKey === "top2") {
        if (item.key === "_i1") {
          thirdNavMap[thirdKey] = [
            {
              key: "_t1",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third3_1_1.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third3_1_1_active.jpg`),
            },
            {
              key: "_t2",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third3_1_3.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third3_1_3_active.jpg`),
            },
            {
              key: "_t3",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third3_1_4.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third3_1_4_active.jpg`),
            },
            {
              key: "_t4",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third3_1_2.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third3_1_2_active.jpg`),
            },
          ]
        } else if (item.key === "_i2") {
          thirdNavMap[thirdKey] = [
            {
              key: "_t1",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third1_2_1.png`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third1_2_1.png`),
            }
          ]
        }
      } else if (firstKey === "top3") {
        if (item.key === "_i1") {
          thirdNavMap[thirdKey] = [
            {
              key: "_t1",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_2.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_2_active.jpg`),
            },
            {
              key: "_t2",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_7.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_7_active.jpg`),
            },
            {
              key: "_t3",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_6.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_6_active.jpg`),
            },
            {
              key: "_t4",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_4.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_4_active.jpg`),
            },
            {
              key: "_t5",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_3.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_3_active.jpg`),
            },
            {
              key: "_t6",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_5.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_5_active.jpg`),
            },
            {
              key: "_t7",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_8.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_8_active.jpg`),
            },
            {
              key: "_t8",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_1.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_1_1_active.jpg`),
            }
          ]
        } else if (item.key === "_i2") {
          thirdNavMap[thirdKey] = [
            {
              key: "_t1",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_2_1.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_2_1_active.jpg`),
            },
            {
              key: "_t2",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_2_6.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_2_6_active.jpg`),
            },
            {
              key: "_t3",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_2_5.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_2_5_active.jpg`),
            },
            {
              key: "_t4",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_2_3.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_2_3_active.jpg`),
            },
            {
              key: "_t5",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_2_2.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_2_2_active.jpg`),
            },
            {
              key: "_t6",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_2_4.jpg`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/weddingDress20220409/nav/third2_2_4_active.jpg`),
            },
          ]
        }
      }
    });
  }
  return thirdNavMap;
}

navData.third = handleThirdNav(navData.bottom);
const pictureList = [];
function handlePictures (pictureList) {
  const pictures = [];
  const pictureListLopp = {
    '1_1': { num: [3, 2], prodId: SINGLE_PRO_ID },
    '1_2': { num: [2], prodId: FAMILY_PRO_ID },
    '2_1': { num: [3, 3, 2, 2], prodId: SINGLE_PRO_ID },
    '2_2': { num: [2], prodId: FAMILY_PRO_ID },
    '3_1': { num: [3,2,2,2,2,2,2,2], prodId: SINGLE_PRO_ID },
    '3_2': { num: [1,1,1,1,1,1], prodId: FAMILY_PRO_ID },
  }
  for (const key in pictureListLopp) {
    const element = pictureListLopp[key];
    element.num.forEach((item, idx) => {
      pictureList.push({
        key: key + '_' + (idx + 1),
        picNum: item,
        pid: element.prodId
      })
    })
  }
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0 } = item;
    const picList = [];
    Array(picNum)
      .fill(0)
      .forEach((item, index) => {
        picList.push(
          require(`../../assets/weddingDress20220409/ctn/${key}_${index + startIndex + 1}.jpg`)
        );
      });
    const indexArr = key.split("_");
    pictures.push({
      id: pid,
      type: "gold",
      ref: `top${indexArr[0]}_i${indexArr[1]}_t${indexArr[2]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      thirdName: `_t${indexArr[2]}`,
      son: picList
    });
  });
  pictures.unshift(...[
    {
      son: [],
      id: SINGLE_PRO_ID,
      type: "gold",
      ref: `top1_i11_t1`,
      farName: `top1`,
      sonName: `_i1`,
      thirdName: `_t1`,
    },
    {
      son: [],
      id: SINGLE_PRO_ID,
      type: "gold",
      ref: `top1_i13_t1`,
      farName: `top1`,
      sonName: `_i1`,
      thirdName: `_t2`,
    }
  ])
  return pictures;
}
const pictures = handlePictures(pictureList);
pictures.push({
  son: [
    require('../../assets/weddingDress20220409/ctn/4_1_1_1.jpg')
  ],
  fun: 'toNewWedding'
})

pictures.push({
  son: [
    require('../../assets/weddingDress20220409/ctn/end.jpg'),
  ],
  type: "gold",
  ref: `top1_i12_t1`,
  farName: `top1`,
  sonName: `_i1`,
  thirdName: `_t1`,
})
function toNewWedding () {
  window.location.href = window.location.origin + window.location.pathname + `?t=${new Date().getTime()}#/theme/weddingDressCooperation20220409`
  // this.$router.push({ path: '/theme/newWedding' })
}

function onlonadFun (_this) {
  _this.toNewWedding = toNewWedding
}

const topDiff = {
  firstSon: "_i1",
  firstThird: "_t1",
  top4_i1_t1: 30
};

export default {
  title: "经典款轻婚纱",
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
  onlonadFun
};
